import { List, ListItem } from '@fluentui/react-components';
import React from 'react';

interface ValidationMessageListProps {
  messages: string[];
}

const ValidationMessageListImpl: React.FC<ValidationMessageListProps> = (props) => {
  const {
    messages,
  } = props;

  return (
    <List>
      {
        messages.map((message, index) => (
          <ListItem key={`${message}-${index}`}>
            {message}
          </ListItem>
        ))
      }
    </List>
  );
};

export const ValidationMessageList = ValidationMessageListImpl;
